export const locale = {
    lang: "en-US",
    data: {
        REGISTER_IDENTITY: {
            TITLE: "Welcome!",
            SUBTITLE: "fill in the fields below to start your journey to becoming a Guru!",

            CREATE: "Save",
            CANCEL: "Cancel",

            REQUIRED: "This field is required.",
            NAME: "Name",
            SURNAME: "Surname",

            USERNAME: {
                REQUIRED: "Email is required.",
                INVALID: "Must fill in a valid email address."
            },

            USERNAME_ALREADY_IN_USER:
                "Email already registered on our platform. If you don't remember your password, use the 'Forgot your password?'",
            GENERIC_ERROR: "Error creating user. Please try again later or contact our support"
        }
    }
};
